import _defineProperty from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _TOKEN_PREDICATE, _ALLOWED_NEXT_TOKENS;
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Terminology inspired from https://www.rfc-editor.org/rfc/rfc9535.html
 *
 * jsonpath-query      = segment*
 * segment             = .name-shorthand / bracketed-selection
 * bracketed-selection = ['name-selector'] / ["name-selector"] / [index-selector]
 *
 * Useful references:
 * - https://goessner.net/articles/JsonPath/
 * - https://jsonpath.com/
 * - https://github.com/jsonpath-standard
 */
/**
 * Extract selectors from a simple JSON path expression, return [] for an invalid path
 *
 * Supports:
 * - Dot notation: `foo.bar.baz`
 * - Bracket notation: `['foo']["bar"]`
 * - Array indices: `items[0]`, `data['users'][1]`
 *
 * Examples:
 * parseJsonPath("['foo'].bar[12]")
 * => ['foo', 'bar', '12']
 *
 * parseJsonPath("['foo")
 * => []
 */
export function parseJsonPath(path) {
  var selectors = [];
  var previousToken = 0 /* Token.START */;
  var currentToken;
  var parsingContext = {
    quote: undefined,
    escapeSequence: undefined
  };
  var currentSelector = '';
  var _iterator = _createForOfIteratorHelper(path),
    _step;
  try {
    var _loop = function _loop() {
        var _char = _step.value;
        // find which kind of token is this char
        currentToken = ALLOWED_NEXT_TOKENS[previousToken].find(function (token) {
          return TOKEN_PREDICATE[token](_char, parsingContext);
        });
        if (!currentToken) {
          return {
            v: []
          };
        }
        if (parsingContext.escapeSequence !== undefined && currentToken !== 12 /* Token.ESCAPE_SEQUENCE_CHAR */) {
          if (!isValidEscapeSequence(parsingContext.escapeSequence)) {
            return {
              v: []
            };
          }
          currentSelector += resolveEscapeSequence(parsingContext.escapeSequence);
          parsingContext.escapeSequence = undefined;
        }
        if (ALLOWED_SELECTOR_TOKENS.includes(currentToken)) {
          // buffer the char if it belongs to the selector
          // ex: foo['bar']
          //      ^    ^
          currentSelector += _char;
        } else if (ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== '') {
          // close the current path part if we have reach a path part delimiter
          // ex: foo.bar['qux']
          //        ^   ^     ^
          selectors.push(currentSelector);
          currentSelector = '';
        } else if (currentToken === 12 /* Token.ESCAPE_SEQUENCE_CHAR */) {
          parsingContext.escapeSequence = parsingContext.escapeSequence ? "".concat(parsingContext.escapeSequence).concat(_char) : _char;
        } else if (currentToken === 8 /* Token.QUOTE_START */) {
          parsingContext.quote = _char;
        } else if (currentToken === 9 /* Token.QUOTE_END */) {
          parsingContext.quote = undefined;
        }
        previousToken = currentToken;
      },
      _ret;
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (!ALLOWED_NEXT_TOKENS[previousToken].includes(1 /* Token.END */)) {
    return [];
  }
  if (currentSelector !== '') {
    selectors.push(currentSelector);
  }
  return selectors;
}
var NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
var NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
var DIGIT_REGEX = /[0-9]/;
var UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
var QUOTE_CHARS = '\'"';
var TOKEN_PREDICATE = (_TOKEN_PREDICATE = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_TOKEN_PREDICATE, 0 /* Token.START */, function _() {
  return false;
}), 1 /* Token.END */, function _() {
  return false;
}), 2 /* Token.NAME_SHORTHAND_FIRST_CHAR */, function _(_char2) {
  return NAME_SHORTHAND_FIRST_CHAR_REGEX.test(_char2);
}), 3 /* Token.NAME_SHORTHAND_CHAR */, function _(_char3) {
  return NAME_SHORTHAND_CHAR_REGEX.test(_char3);
}), 4 /* Token.DOT */, function _(_char4) {
  return _char4 === '.';
}), 5 /* Token.BRACKET_START */, function _(_char5) {
  return _char5 === '[';
}), 6 /* Token.BRACKET_END */, function _(_char6) {
  return _char6 === ']';
}), 7 /* Token.DIGIT */, function _(_char7) {
  return DIGIT_REGEX.test(_char7);
}), 8 /* Token.QUOTE_START */, function _(_char8) {
  return QUOTE_CHARS.includes(_char8);
}), 9 /* Token.QUOTE_END */, function _(_char9, parsingContext) {
  return _char9 === parsingContext.quote;
}), _defineProperty(_defineProperty(_defineProperty(_TOKEN_PREDICATE, 10 /* Token.NAME_SELECTOR_CHAR */, function _() {
  return true;
}), 11 /* Token.ESCAPE */, function _(_char0) {
  return _char0 === '\\';
}), 12 /* Token.ESCAPE_SEQUENCE_CHAR */, function _(_char1, parsingContext) {
  if (parsingContext.escapeSequence === undefined) {
    // see https://www.rfc-editor.org/rfc/rfc9535.html#name-semantics-3
    return "".concat(parsingContext.quote, "/\\bfnrtu").includes(_char1);
  } else if (parsingContext.escapeSequence.startsWith('u') && parsingContext.escapeSequence.length < 5) {
    return UNICODE_CHAR_REGEX.test(_char1);
  }
  return false;
}));
var ALLOWED_NEXT_TOKENS = (_ALLOWED_NEXT_TOKENS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_ALLOWED_NEXT_TOKENS, 0 /* Token.START */, [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */, 5 /* Token.BRACKET_START */]), 1 /* Token.END */, []), 2 /* Token.NAME_SHORTHAND_FIRST_CHAR */, [3 /* Token.NAME_SHORTHAND_CHAR */, 4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */]), 3 /* Token.NAME_SHORTHAND_CHAR */, [3 /* Token.NAME_SHORTHAND_CHAR */, 4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */]), 4 /* Token.DOT */, [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */]), 5 /* Token.BRACKET_START */, [8 /* Token.QUOTE_START */, 7 /* Token.DIGIT */]), 6 /* Token.BRACKET_END */, [4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 1 /* Token.END */]), 7 /* Token.DIGIT */, [7 /* Token.DIGIT */, 6 /* Token.BRACKET_END */]), 8 /* Token.QUOTE_START */, [11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */]), 9 /* Token.QUOTE_END */, [6 /* Token.BRACKET_END */]), _defineProperty(_defineProperty(_defineProperty(_ALLOWED_NEXT_TOKENS, 10 /* Token.NAME_SELECTOR_CHAR */, [11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */]), 11 /* Token.ESCAPE */, [12 /* Token.ESCAPE_SEQUENCE_CHAR */]), 12 /* Token.ESCAPE_SEQUENCE_CHAR */, [12 /* Token.ESCAPE_SEQUENCE_CHAR */, 11 /* Token.ESCAPE */, 9 /* Token.QUOTE_END */, 10 /* Token.NAME_SELECTOR_CHAR */]));
// foo['bar\n'][12]
// ^^    ^ ^^   ^
var ALLOWED_SELECTOR_TOKENS = [2 /* Token.NAME_SHORTHAND_FIRST_CHAR */, 3 /* Token.NAME_SHORTHAND_CHAR */, 7 /* Token.DIGIT */, 10 /* Token.NAME_SELECTOR_CHAR */];
// foo.bar['qux']
//    ^   ^     ^
var ALLOWED_SELECTOR_DELIMITER_TOKENS = [4 /* Token.DOT */, 5 /* Token.BRACKET_START */, 6 /* Token.BRACKET_END */];
function isValidEscapeSequence(escapeSequence) {
  return '"\'/\\bfnrt'.includes(escapeSequence) || escapeSequence.startsWith('u') && escapeSequence.length === 5;
}
var ESCAPED_CHARS = {
  '"': '"',
  "'": "'",
  '/': '/',
  '\\': '\\',
  b: '\b',
  f: '\f',
  n: '\n',
  r: '\r',
  t: '\t'
};
function resolveEscapeSequence(escapeSequence) {
  if (escapeSequence.startsWith('u')) {
    // build Unicode char from code
    return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
  }
  return ESCAPED_CHARS[escapeSequence];
}